import { Component, Input } from '@angular/core';
import { Building } from '../../models/response-building-data';
import { CommonModule } from '@angular/common';
import { TablePaginationComponent } from 'src/app/pages/common/table-pagination/table-pagination.component';

@Component({
  selector: 'app-response-buildings-data',
  standalone: true,
  imports: [CommonModule, TablePaginationComponent],
  templateUrl: './response-buildings-data.component.html'
})
export class ResponseBuildingsDataComponent {
    @Input() response: Building[]=[];
    tableData:Building[]=[];
    
    updateRecord(data:Building[]){
     setTimeout(() => {
       this.tableData = data;
     }, 0);
    }

}
